import LegacyRecommendedItems from "common/components/LegacyRecommendedItems";
import SearchExperienceRecommendedItems from "common/components/SearchExperienceRecommendedItems";
import { CATALOG_PROVIDER } from "config";
import React, { FC } from "react";

export interface IRecommendedItemsProps {
  totalItems: number;
  categoryToFilterBy: string;
  perRow: number;
  useSmartRecommendations?: boolean;
  recommendedItemsData?: any;
  isLoadingRecommendations?: boolean;
  recommendationsError?: Error | null;
  children?: any;
  toggleSearchExperience?: boolean;
  trafficFrom: string;
}

export const mappingToTags: { [key: string]: string } = {
  topPicks: "Top-picks",
  communicationTools: "Communication-tools",
};

const RecommendedItemsFactory: FC<IRecommendedItemsProps> = (props: IRecommendedItemsProps) => {
  if (props.toggleSearchExperience && !props.useSmartRecommendations) {
    return (
      <SearchExperienceRecommendedItems
        totalItems={props.totalItems}
        perRow={props.perRow}
        tagToFilterBy={mappingToTags[props.categoryToFilterBy]}
        pageSize={3}
        categoryToFilterBy="Communication Tools"
      >
        {props.children}
      </SearchExperienceRecommendedItems>
    );
  } else {
    return (
      <LegacyRecommendedItems
        totalItems={props.totalItems}
        perRow={props.perRow}
        tagToFilterBy={mappingToTags[props.categoryToFilterBy]}
        useSmartRecommendations={props.useSmartRecommendations}
        recommendedItemsData={props.recommendedItemsData}
        isLoadingRecommendations={props.isLoadingRecommendations}
        recommendationsError={props.recommendationsError}
        trafficFrom={props.trafficFrom}
      >
        {props.children}
      </LegacyRecommendedItems>
    );
  }
};

export default RecommendedItemsFactory;
